<template>
    <div>
        <modal :name="modal_name" class="final-modal activity-popup" transition="nice-modal-fade" >
            <div class="v-modal-content" style="border-radius: 5px !important;">
                <div class="v-modal-header d-flex align-items-center justify-content-end">
                    <span @click="hideType()" class="closePopup">
                        <i class="icon-close text-secondary fw-600"></i>
                    </span>
                </div>
                <div class="v-modal-body pt-0 pb-0">
                    <div class="v-modal-layout d-form pb-5" style="overflow: initial !important;">
                        <div v-if="ajaxCall">
                            <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
                        </div>
                        <div class="activty-content" v-else>
                            <div>
                                <span class="greencircle">
                                    <span class="fs-15 fw-600">{{allActivity.created_date.split(' ')[0]}}</span>
                                    <span class="fw-600">{{allActivity.created_date.split(' ')[1] + ' ' +  allActivity.created_date.split(' ') [2] }}</span>
                                    <span class="fw-400">{{allActivity.created_date.split(' ')[3] + ' ' +  allActivity.created_date.split(' ') [4] }}</span>
                                    <!-- <span class="fw-400">{{allActivity.time}}</span>  -->
                                </span>
                            </div>
                            <div class="activty-bg">
                                <div class="unfinishedCircleText">
                                    <div class="activityname">
                                        <!-- <p class="mb-0">{{allActivity.activity || '-'}}</p> -->
                                        <div class="mb-0 w-100 overflowing-text" v-if="allActivity.activity" :title="allActivity.activity">
                                            <span class="text-capitalize">{{allActivity.activity || '-'}}</span>
                                        </div>
                                        <!-- <span>{{activity.activity.split(' ')[3] }} </span> -->
                                    </div>
                                    <div class="mt-2">
                                        <span class="text-danger">Action : </span>
                                        <span class="text-capitalize">{{allActivity.action || '-'}}</span>
                                    </div>
                                    <div class="mt-2">
                                        <span class="text-danger">Date : </span>
                                        <span class="text-capitalize">{{allActivity.date || '-'}}</span>
                                    </div>
                                    <div class="mt-2">
                                        <span class="text-danger">Time : </span>
                                        <span class="text-capitalize">{{allActivity.time || '-' }}</span>
                                    </div>
                                    <!-- <div class="mt-2">
                                        <span class="text-danger">Location : </span>
                                        <span>{{allActivity.location || '-'}}</span>
                                    </div> -->
                                    <div class="mt-2 mb-2" style="border:1px solid #005dae"></div>
                                    <!-- created -->
                                    <div v-if="allActivity.type == 'create_ticket' ">
                                        <div>
                                            <span class="fw-500">Ticket Subject: </span>
                                            <span class="text-capitalize">{{allActivity.details.ticket_subject || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Description: </span>
                                            <span class="description-content" v-html="allActivity.details.description">
                                            </span>
                                        </div>
                                    </div>
                                    <div v-if="allActivity.type == 'create_service_ticket' ">
                                        <div>
                                            <span class="fw-500">Ticket Subject: </span>
                                            <span class="text-capitalize">{{allActivity.details.ticket_subject || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Description: </span>
                                            <span class="description-content" v-html="allActivity.details.description">
                                            </span>
                                        </div>
                                    </div>
                                    <!-- Edited -->
                                    <div v-if="allActivity.type == 'edited' ">
                                        <table class="w-100 activity-table ">
                                            <thead>
                                                <tr>
                                                    <th>Field Name</th>
                                                    <th>Changed from</th>
                                                    <th>Changed to</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="allActivity.details.edit_data.length == 0" class="text-center font-weight-bold">
                                                    <td colspan="3">No Status</td>
                                                </tr>
                                                <tr v-for="(status,index) in allActivity.details.edit_data" :key="index">
                                                    <td class="text-capitalize">{{status.field_name || '-'}}</td>
                                                    <td class="text-capitalize">{{status.from || '-'}}</td>
                                                    <td class="text-capitalize description-content" v-html="status.to"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div>
                                        <!-- Commented -->
                                        <div class="mt-3 text-capitalize" v-if="allActivity.type == 'commented' ">
                                             {{allActivity.details.comment || '-' }}
                                        </div>

                                        <!-- changed_assigned_user -->
                                        <div class="mt-3 fw-500 text-capitalize" v-if="allActivity.type == 'changed_assigned_user'">{{allActivity.details.changed_assigned_user || '-' }}</div>

                                        <!-- Download -->
                                        <div class="mt-3 fw-500 text-capitalize" v-if="allActivity.type == 'download'">{{allActivity.details.download || '-' }}</div>

                                        <!-- Change Statsus -->
                                        <div class="mt-3 fw-500 text-capitalize" v-if="allActivity.type == 'changed_status'">{{allActivity.details.changed_status || '-' }}</div>

                                        <!-- new_assignment -->
                                        <div class="mt-3 fw-500 text-capitalize" v-if="allActivity.type == 'new_assignment'">{{allActivity.details.assignment || '-' }}</div>
                                    </div>
                                    <!-- Sent Mail -->
                                    <div v-if="allActivity.type == 'sent_email'">
                                        <div class="fw-500">Hi <span class="text-capitalize">{{allActivity.details.email.assigned_to || '-' }}</span></div>
                                        <div  class="fs-12">
                                            <span class="fw-500">Ticket Number : </span>
                                            <span class="text-capitalize">{{allActivity.details.email.ticket_number  || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Subject : </span>
                                            <span class="text-capitalize">{{allActivity.details.email.subject || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Assigned by : </span>
                                            <span class="text-capitalize">{{allActivity.details.email.assigned_by || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Assigned Time : </span>
                                            <span class="text-capitalize">{{allActivity.details.email.assigned_time || '-' }}</span>
                                            <span v-if="allActivity.details.email.assigned_time" class="ml-2">IST</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Helpdesk Status : </span>
                                            <span class="text-capitalize">{{allActivity.details.email.hasOwnProperty('helpdesk_status') ? allActivity.details.email.helpdesk_status : allActivity.details.email.ticket_status|| '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Ticket Associated Product :  </span>
                                            <span class="text-capitalize">{{Object.keys(this.allActivity.details.email).length > 0 ? allActivity.details.email.ticket_associated_product.toString(', ') : '-' || '-' }}</span>
                                        </div>
                                        <!-- <div class="mt-3">
                                            <span class="fw-500">Ticket tagged Under:</span>
                                            Cloud
                                        </div> -->
                                        <div class="mt-3">
                                            <span class="fw-500">Ticket Priority  : </span>
                                            <span class="text-capitalize">{{allActivity.details.email.hasOwnProperty('ticket_priority') ? allActivity.details.email.ticket_priority : allActivity.details.email.priority || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Ticket Description :  </span>
                                            <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text" :title="allActivity.  details.email.ticket_description">
                                                <span v-if="allActivity.details.email.ticket_description" class="text-capitalize description-content" v-html="allActivity.details.email.ticket_description"></span>
                                                <span v-else>-</span>
                                            </div>
                                        </div>
                                        <div class="mt-3 fw-500">Thanks,</div>
                                        <div class="fw-500">Helpdesk Team</div>
                                    </div>
                                    <!-- replied_to_an_email -->
                                    <div v-if="allActivity.type == 'replied_to_an_email'">
                                        <div class="fw-500">Hi <span class="text-capitalize">{{allActivity.details.email.assigned_to || '-' }}</span></div>
                                        <div class="fs-12">
                                            <span class="fw-500">Ticket Number :  </span>
                                            <span class="text-capitalize">{{allActivity.details.email.ticket_number || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Subject :  </span>
                                            <span class="text-capitalize">{{allActivity.details.email.subject || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Assigned by :  </span>
                                            <span class="text-capitalize">{{allActivity.details.email.assigned_by || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Assigned Time :  </span>
                                            <span class="text-capitalize">{{allActivity.details.email.assigned_time || '-' }}</span>
                                            <span v-if="allActivity.details.email.assigned_time" class="ml-2">IST</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Helpdesk Status :  </span>
                                            <span class="text-capitalize">{{allActivity.details.email.hasOwnProperty('helpdesk_status') ? allActivity.details.email.helpdesk_status : allActivity.details.email.ticket_status || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Ticket Associated Product :  </span>
                                            <span class="text-capitalize">{{Object.keys(this.allActivity.details.email).length > 0 ? allActivity.details.email.ticket_associated_product.toString(', ') : '-' || '-' }}</span>
                                        </div>
                                        <!-- <div class="mt-3">
                                            <span class="fw-500">Ticket tagged Under:</span>
                                            Cloud
                                        </div> -->
                                        <div class="mt-3">
                                            <span class="fw-500">Ticket Priority :  </span>
                                            <span class="text-capitalize">{{allActivity.details.email.hasOwnProperty('ticket_priority') ? allActivity.details.email.ticket_priority : allActivity.details.email.priority || '-' }}</span>
                                        </div>
                                        <div class="mt-3">
                                            <span class="fw-500">Ticket Description :  </span>
                                            <span class="text-capitalize description-content" v-html="allActivity.details.email.ticket_description"></span>
                                        </div>
                                        <div class="mt-3 fw-500">Thanks,</div>
                                        <div class="fw-500">Helpdesk Team</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import ticket from '../mixins/ticket.js';
export default {
    mixins:[ticket],
    props:['modal_name','activity_id'],
    data(){
        return{
            allActivity:{
                created_date:'',
                activity:'',
                action:'',
                date:'',
                time:'',
                location:''
            },

            ajaxCall:false,
        }
    },
    methods:{
        hideType(){
            this.$modal.hide(this.modal_name);
            this.$emit("activityByIdHide")
        },
        async getDetails(){
            try {
                this.ajaxCall = true
                let params={
                    activity_id : this.activity_id
                }
                let res = await this.getActivityById(params)
                this.allActivity = res.response
                if(this.allActivity.details.hasOwnProperty('email') && Object.keys(this.allActivity.details.email).length > 0){
                    let find_img = this.allActivity.details.email.ticket_description.split(' ')
                    var new_arr = []
                    if(!find_img.includes('<!DOCTYPE')){
                        find_img.forEach((im, im_index) => {
                            let regex = /[a-zA-Z0-9]{1,}<img+/i
                            if(regex.test(im)){
                                new_arr.splice(im_index, 0, 'class="w-100"')
                                new_arr.splice(im_index, 0, im)
                            } else if(im == '<img'){
                                new_arr.splice(im_index, 0, 'class="w-100"')
                                new_arr.splice(im_index, 0, im)
                            } else if(im.endsWith('><img')){
                                let d = im.slice(0,im.length-4)
                                new_arr.push(d)
                                new_arr.push('<img class="w-100"')
                            } else {
                                new_arr.push(im)
                            }
                        })
                    }
                    this.allActivity.details.email.ticket_description = new_arr.join(" ")
                }
                this.ajaxCall = false
            } catch (reason) {

            }
        },
    },
    async mounted() {
        this.getDetails()
    },
}
</script>
<style scoped>
.closePopup{
    background-color: transparent !important;
    font-weight: 600;
    font-size: 20px;
    margin-right: 7px;
    color: #005dae;
    cursor: pointer;
}
.activty-content{
    display: flex;
    /* align-items: center; */
    background-color: transparent;
    margin: 0px 10px;
}
.activty-bg{
  margin: 0 0 0 20px;
  padding:10px;
  border-radius: 1.5px;
  background-color: #a1cbfb;
  width: 100%;
}
.activty-content .greencircle{
  color: #ffffff !important;
  text-align: right;
  font-weight: 500;
  font-size: 12px;
  text-align: right;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  top: 0px;
  background: #25bb83;
  border-radius: 50%;
  height: 70px;
  width: 70px;
}
.activity-table thead tr th{
    background-color: #dfe8f2;
    padding: 10px;
    border: 1px solid #9cbef3;
}
.activity-table tbody tr{
    height: 45px;
}
.activity-table tbody tr td{
    padding: 10px;
    /* border-right: 1px solid #000; */
}
.activity-table tbody tr:nth-of-type(odd) {
    background-color: #f0f4f7;
    padding-left:10px;
}
.activity-table tbody tr:nth-of-type(even) {
    background-color:#fafdfe;
}
.activty-bg{
    max-width: 450px;
    min-width: 200px;
}
.capital-first-letter::first-letter {
    text-transform:capitalize;
}
.description-content{
    line-break: anywhere;
    white-space: pre-wrap;
}
.v-modal-body{
    overflow: auto !important;
}
</style>